import React, { useState } from "react";
import { formattedAmount } from "../../../utils/helpers/Functions.helper";
import moment from "moment/moment";
import { Badge } from "primereact/badge";
import AssignOrderModal from "./AssignOrderModal";

const DispatchOrderCard = ({
  item,
  selectedTab,
  allDeliveryMan,
  deliveryBusiness,
  fetchAllData,
  fetchAllDeliveryMan,
}) => {
  const deliveryStatus =
    deliveryBusiness === "Ecommerce"
      ? item?.orderDetails?.[0]?.delivery_status
      : item?.delivery_status;
  const [isAssignModal, setIsAssignModal] = useState(false);
  const [isAssignItem, setIsAssignItem] = useState("");
  console.log("item order:", item);

  return (
    <div className="shadow p-2 rounded-md w-[100%] ">
      <p>
        <strong>Order ID:</strong> {item.order_id}
      </p>
      {/* <p><strong>Number of Items:</strong> {item.orderDetails.length}</p> */}
      <p>
        <small>Order Cost:</small>{" "}
        {formattedAmount(
          item?.orderDetails?.reduce((total, detail) => {
            const price = parseFloat(detail.price?.$numberDecimal || 0);
            return total + price;
          }, 0)
        )}
      </p>

      <p>
        <small>Order Date:</small>
        {moment(item.order_date).format("MMM Do, YYYY")}
      </p>
      <p>
        <small>Order Type:</small>
        {item.order_type}
      </p>
      <p className=" overflow-hidden">
        <small>Del. Address:</small>
        {item.delivery_address.street},{item.delivery_address.city.name},
        {item.delivery_address.country.name}
      </p>
      <div className="flex justify-center items-center">
        {/* <Badge
            className="text-[15px] px-4"
            severity={"info"}
            value={deliveryStatus === "ASSIGNED" ? "Assigning": "N/A" }
          /> */}
        {/* <SecondaryButton
        padding='px-2 py-1'
        borderColor='border-blue500'
          onClick={() => {
            setIsAssignModal(true);
            setIsAssignItem(item);
          }}
          text="Assign for Delivery"
        /> */}
        {!selectedTab ?(
           <button
           className="py-1 w-full border text-[14px] border-blue500 text-blue600 rounded-md hover:bg-blue-100"
           onClick={() => {
             setIsAssignModal(true);
             setIsAssignItem(item);
             fetchAllDeliveryMan();
           }}
         >
           Assign for Delivery
         </button>
        ):(
          <Badge
            className="text-[10px] px-4"
            severity={"info"}
            value={deliveryStatus==="Assigned"?"assign pending":deliveryBusiness === "Ecommerce"
              ? item?.orderDetails?.[0]?.delivery_status
              : item?.delivery_status}
          />
        )}
      </div>
      {isAssignModal && (
        <AssignOrderModal
        fetchAllData={fetchAllData}
          isAssignModal={isAssignModal}z
          itemData={isAssignItem}
          deliveryBusiness={deliveryBusiness}
          setIsAssignModal={setIsAssignModal}
          allDeliveryMan={allDeliveryMan}
        />
      )}
    </div>
  );
};

export default DispatchOrderCard;
